// extracted by mini-css-extract-plugin
export default {"mainContainer":"loader_theme_mainContainer__JaIKq","loader":"loader_theme_loader__L1JsG","spin":"loader_theme_spin__+SI5H"};